import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import CityDetailPage from '@/components/pages/guest/_ext-intitutions/containers/details/city'

export const Route = createFileRoute(
  '/_guest/guest/extensions-institutions/city/$id'
)({
  component: RouteComponent,
  validateSearch: z.object({
    province_code: z.string().optional()
  })
})

function RouteComponent() {
  const { id } = Route.useParams()

  return <CityDetailPage cityId={id} />
}
